import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/locations";

// Fetch Locations
export const fetchLocations = createAsyncThunk("locations/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Location
export const addLocation = createAsyncThunk("locations/add", async (locationData) => {
  const response = await hrmsPostRequest(API_URL, locationData);
  return response.data;
});

// Update Location
export const updateLocation = createAsyncThunk("locations/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Location
export const deleteLocation = createAsyncThunk("locations/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const locationSlice = createSlice({
  name: "locations",
  initialState: {
    locations: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.locations = action.payload;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addLocation.fulfilled, (state, action) => {
        state.locations.push(action.payload);
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        const index = state.locations.findIndex((loc) => loc.id === action.payload.id);
        if (index !== -1) {
          state.locations[index] = action.payload;
        }
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.locations = state.locations.filter((loc) => loc.id !== action.payload);
      });
  },
});

export default locationSlice.reducer;